import * as React from 'react';

import { ILocalization } from 'bernie-l10n';

import { RoomConfig } from 'components/common/room-picker/room-picker-model';

import { UitkSelect } from 'uitk-react-select';

export interface ChildrenAgesProps {
  room: RoomConfig;
  childAge: number;
  childIndex: number;
  onChildAgeUpdated: (childIndex, target) => void;
  roomIndex: number;
  l10n: ILocalization;
  selectLabel: string;
}

export interface ChildAgeSelectOptions {
  value: string;
  name: string;
}

const MIN_CHILD_AGE: number = 0;
const MAX_CHILD_AGE: number = 17;

export const ChildrenAges = ({ childAge, childIndex, l10n, onChildAgeUpdated, roomIndex, selectLabel }: ChildrenAgesProps) => {
  const options = getChildrenAgeSelectOptions(l10n);

  // Need access to variables in scope.
  const updatedAges = e => onChildAgeUpdated(childIndex, e.target);

  return (
    <div className="uitk-cell all-cell-1-2">
      <UitkSelect
        label={selectLabel}
        id={`age-${childIndex}`}
        name={`child-${roomIndex}-${childIndex}`}
        value={childAge.toString()}
        onChange={updatedAges}
      >
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.name}
          </option>
        ))}
      </UitkSelect>
    </div>
  );
};

const getChildrenAgeSelectOptions = (l10n: ILocalization): ChildAgeSelectOptions[] => {
  const options: ChildAgeSelectOptions[] = [];
  for (let i = MIN_CHILD_AGE; i <= MAX_CHILD_AGE; i++) {
    const name = i === 0 ? l10n.formatText('hotels.roomPicker.youngestChildAge.text') : i;

    options.push({
      value: `${i}`,
      name: `${name}`
    });
  }

  return options;
};
